module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.REPORT_STAFF, _vm.USER_ROLES.SALES_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF,USER_ROLES.SALES_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.REPORT_STAFF]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [(this.forDelete.length > 0) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.deleteMultiple
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ReportCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Generate New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "reportgenerationTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(props) {
        return [_c('div', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": this.deleteIds && this.deleteIds.length > 0 && this.deleteIds.includes(props.row._id)
          },
          on: {
            "change": function($event) {
              _vm.multiDelete($event, props.row)
            }
          }
        })])]
      }
    }, {
      key: "download",
      fn: function(props) {
        return [_c('div', [_c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.download(props.row)
            }
          }
        }, [_vm._v("Download")])])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [_c('div', [_c('a', {
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteReport(props.row)
            }
          }
        }, [_vm._v("Delete")])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35b8edc3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b8edc3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/reports/Report.vue
// module id = 2295
// module chunks = 0